import { createAction,props } from '@ngrx/store';
import { Agency } from '../../shared/models/agency.model';

//export const LOADING = '[Agencys Component] Loading';
export const LOAD_AGENCYS = '[Agencys Component] Load Agencys';
//export const LOAD_AGENCY_ERROR = '[Agencys Component] Load Agencys';
export const GET_AGENCYS = '[Agencys Component] Get Agencys';
// export const LOAD_AGENCYS_ERROR = '[Agencys Component] Load Agencys';
// export const LOAD_ADD_AGENCYS = '[Agencys Component] Load Add Agencys';
// export const LOAD_ADD_AGENCYS_ERROR = '[Agencys Component] Load Add Agencys Error';
// export const LOAD_UPDATE_AGENCYS = '[Agencys Component] Load Update Agencys';
// export const LOAD_UPDATE_AGENCYS_ERROR = '[Agencys Component] Load Update Agencys Error';
//
// export const LOAD_DELETE_AGENCYS = '[Agencys Component] Load Delete Agencys';
// export const ADD_AGENCY = '[Agencys Component] Add Agency';
// export const ADD_AGENCYS = '[Agencys Component] Add Agencys';
// export const RESET_AGENCYS = '[Agencys Component] Reset Agencys';
// export const DELETE_AGENCYS = '[Agencys Component] Delete Agencys';
// export const UPDATE_AGENCYS = '[Agencys Component] Update Agencys';
// export const START_EDIT_AGENCYS = '[Agencys Component] Start Edit Agencys';
// export const STOP_EDIT_AGENCYS = '[Agencys Component] Stop Edit Agencys';


export const loadAgencys = createAction(
  LOAD_AGENCYS
);


export const getAgencys = createAction(
  GET_AGENCYS,
  props<String>()
);



//export type AgencyListsActions = get_agencys

